const initialState = {
  appDetails: [],
  appReviews: {},
  loading: false
};

export const AppDetailsActionType = {
  SET_APPS_LOADING: "SET_APPS_LOADING",
  SET_APP_DETAILS: "SET_APP_DETAILS",
  SET_APP_REVIEWS: "SET_APP_REVIEWS",
  SET_APP_REVIEW: "SET_APP_REVIEW",
  REMOVE_APP_DETAILS: "REMOVE_APP_DETAILS"
};

export function appDetailReducer(state = initialState, action) {
  switch (action.type) {
    case AppDetailsActionType.SET_APP_DETAILS: {
      const { appDetails } = action.payload;
      return {
        ...state,
        appDetails
      };
    }

    case AppDetailsActionType.SET_APPS_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case AppDetailsActionType.SET_APP_REVIEW: {
      const dupl = structuredClone(state);
      const toChange = dupl.appDetails.find((x) => x.appid === action.payload.appid);
      toChange.review = action.payload.review;
      return dupl;
    }
    case AppDetailsActionType.REMOVE_APP_DETAILS: {
      const { appid } = action.payload;
      return {
        ...state,
        appDetails: state.appDetails.filter((item) => item.appid !== appid)
      };
    }

    case AppDetailsActionType.SET_APP_REVIEWS: {
      return {
        ...state,
        appReviews: {
          ...state.appReviews,
          [action.payload.appid]: action.payload.reviews
        }
      };
    }
    default:
      return state;
  }
}
